import { render, staticRenderFns } from "./HomeImageCarousel.vue?vue&type=template&id=335324b2&scoped=true&"
import script from "./HomeImageCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeImageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomeImageCarousel.vue?vue&type=style&index=0&id=335324b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335324b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335324b2')) {
      api.createRecord('335324b2', component.options)
    } else {
      api.reload('335324b2', component.options)
    }
    module.hot.accept("./HomeImageCarousel.vue?vue&type=template&id=335324b2&scoped=true&", function () {
      api.rerender('335324b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Home/HomeImageCarousel.vue"
export default component.exports